import React, { useEffect, useState } from "react";
import { useId24 } from "../../drivers/id24/Id24Provider";
import { LuckyDrawService } from "./services/lucky-draw.service";
import { Card, Table, TablePaginationConfig } from "antd";
import { loadAppConfig } from "../../configs/app-config";

type Tlucky = {
  id: number;
  nameLucky: string;
};

export const IndexLuckyDraw: React.FC = (): React.ReactElement => {
  const { id24Axios } = useId24();
  const apiBaseUrl = id24Axios(loadAppConfig().REACT_APP_API_BASE_URL);
  const [dataLucky, serLucky] = useState<Tlucky[]>([]);
  const [pagination, setPagination] = useState<{
    current: number;
    pageSize: number;
  }>({ current: 1, pageSize: 10 });

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const lucky = await LuckyDrawService(apiBaseUrl).findAll();
    serLucky(lucky);
  };

  const columns = [
    {
      title: "number",
      dataIndex: "id",
      key: "id",
      render: (d: string, r: any, index: number) =>
        index + 1 + (pagination.current - 1) * pagination.pageSize,
    },
    {
      title: "name lucky",
      dataIndex: "nameLucky",
      key: "nameLucky",
    },
    {
      title: "สุ่มรางวัล",
      dataIndex: "id",
      key: "id",
      render: (_: any, record: any) => (
        <a href={`luckydraw/${_}`}>เข้าสู่หน้า-สุ่มรางวัล</a>
      ),
    },
    {
      title: "กดสุ่มรางวัล",
      dataIndex: "id",
      key: "id",
      render: (value: any, record: any) => (
        <a href={`lucky-draw/${value}`}>เข้าสู่หน้า-กดสุ่มรางวัล</a>
      ),
    },
  ];

  const onChangeTable = (pagination: TablePaginationConfig) => {
    const { current, pageSize } = pagination;
    setPagination({ current: current || 1, pageSize: pageSize || 10 });
  };

  return (
    <Card className="w-full">
      <Table
        dataSource={dataLucky}
        columns={columns}
        rowKey={"id"}
        onChange={onChangeTable}
        pagination={{
          ...pagination,
          defaultPageSize: 10,
          total: dataLucky.length,
          showSizeChanger: true,
        }}
      />
    </Card>
  );
};
